import OpcoesTributarias from "../shared/OpcoesTributarias.js";

export default class NfsePrefeitura {
    constructor() {
        this.dados = {
            id: "",
            numero: "",
            status: 0,
            tomador: { id: "", content: "" },
            servico: { id: "", content: "" },
            locacao: { id: "", content: "" },
            codigoCidadeIncidencia: "",
            descricaoCidadeIncidencia: { id: "", content: "" },
            descricao: "",
            json: "",
            valorNota: 0,
            emails: [],
            mensagemErro: "",
            urlReceita: "",
            urlPdf: "",
            urlXml: "",
        };

        this.regimeTributario = {
            optanteSimplesNacional: true,
            regimeTributario: { id: "1", content: "Simples Nacional" },
            regimeEspecialTributacao: { id: "0", content: "Nenhum" },
            incentivadorCultural: false,
            naturezaOperacao: { id: "1", content: "Tributação no Município" },
            codigoIndicadorOperacao: "",
            ibsCbsClassificacaoTributaria: "",
            ibsCbsSituacaoTributaria: "",
        };

        this.imposto = {
            issRetido: false,
            issAliquota: 0,
            pisCofinsRetido: false,
            pisAliquota: 0,
            cofinsAliquota: 0,
            csllAliquota: 0,
            irAliquota: 0,
            ibsAliquota: 0,
            cbsAliquota: 0,
        };

        this.transparencia = {
            percentualTotalTributosFederais: 0,
            percentualTotalTributosEstaduais: 0,
            percentualTotalTributosMunicipais: 0,
        };
    }

    static createObj(nfsePrefeitura) {
        const dados = nfsePrefeitura.dados;
        const regime = nfsePrefeitura.regimeTributario;
        const imposto = nfsePrefeitura.imposto;
        const transparencia = nfsePrefeitura.transparencia;

        return {
            id: dados.id,

            tomador: dados.tomador,
            servico: dados.servico,
            locacao: dados.locacao,

            optanteSimplesNacional: regime.optanteSimplesNacional,
            regimeTributario: Number(regime.regimeTributario?.id || 0),
            regimeEspecialTributacao: Number(regime.regimeEspecialTributacao?.id || 0),
            incentivadorCultural: regime.incentivadorCultural,
            naturezaOperacao: Number(regime.naturezaOperacao?.id || 0),

            codigoIndicadorOperacao: regime.codigoIndicadorOperacao?.id || regime.codigoIndicadorOperacao || "",
            ibsCbsClassificacaoTributaria: regime.ibsCbsClassificacaoTributaria?.id || regime.ibsCbsClassificacaoTributaria || "",
            ibsCbsSituacaoTributaria: regime.ibsCbsSituacaoTributaria?.id || regime.ibsCbsSituacaoTributaria || "",

            codigoCidadeIncidencia: dados.codigoCidadeIncidencia?.id || dados.codigoCidadeIncidencia || "",
            descricaoCidadeIncidencia: dados.descricaoCidadeIncidencia?.id || dados.descricaoCidadeIncidencia || "",
            descricao: dados.descricao,
            valorNota: dados.valorNota,
            emails: dados.emails,

            issRetido: imposto.issRetido,
            issAliquota: imposto.issAliquota,
            pisCofinsRetido: imposto.pisCofinsRetido,
            pisAliquota: imposto.pisAliquota,
            cofinsAliquota: imposto.cofinsAliquota,
            csllAliquota: imposto.csllAliquota,
            irAliquota: imposto.irAliquota,
            ibsAliquota: imposto.ibsAliquota,
            cbsAliquota: imposto.cbsAliquota,

            percentualTotalTributosFederais: transparencia.percentualTotalTributosFederais,
            percentualTotalTributosEstaduais: transparencia.percentualTotalTributosEstaduais,
            percentualTotalTributosMunicipais: transparencia.percentualTotalTributosMunicipais,
        };
    }

    static updateObj(nfsePrefeitura, data) {
        const dados = data?.dados || data || {};
        const regimeTributario = data?.regimeTributario || data || {};
        const reformaTributaria = data?.reformaTributaria || data || {};
        const imposto = data?.imposto || data || {};
        const ibs = data?.ibs || data || {};
        const cbs = data?.cbs || data || {};
        const transparencia = data?.transparencia || data || {};

        const regimeTributarioValue = regimeTributario.regimeTributario;
        const regimeEspecialTributacaoValue = regimeTributario.regimeEspecialTributacao;
        const naturezaOperacaoValue = regimeTributario.naturezaOperacao;
        const codigoIndicadorOperacaoValue = reformaTributaria.codigoIndicadorOperacao || regimeTributario.codigoIndicadorOperacao;
        const ibsCbsClassificacaoTributariaValue = reformaTributaria.ibsCbsClassificacaoTributaria || regimeTributario.ibsCbsClassificacaoTributaria;
        const ibsCbsSituacaoTributariaValue = reformaTributaria.ibsCbsSituacaoTributaria || regimeTributario.ibsCbsSituacaoTributaria;

        const regimeTributarioId = regimeTributarioValue?.id ?? regimeTributarioValue;
        const regimeEspecialTributacaoId = regimeEspecialTributacaoValue?.id ?? regimeEspecialTributacaoValue;
        const naturezaOperacaoId = naturezaOperacaoValue?.id ?? naturezaOperacaoValue;
        const codigoIndicadorOperacaoId = codigoIndicadorOperacaoValue?.id ?? codigoIndicadorOperacaoValue;
        const ibsCbsClassificacaoTributariaId = ibsCbsClassificacaoTributariaValue?.id ?? ibsCbsClassificacaoTributariaValue;
        const ibsCbsSituacaoTributariaId = ibsCbsSituacaoTributariaValue?.id ?? ibsCbsSituacaoTributariaValue;
        
        const descricaoCidadeIncidenciaObj = typeof dados.descricaoCidadeIncidencia === "object" && dados.descricaoCidadeIncidencia !== null
            ? {
                id: (dados.descricaoCidadeIncidencia.id || dados.codigoCidadeIncidencia || "").toString(),
                content: dados.descricaoCidadeIncidencia.content || "",
            }
            : {
                id: (dados.codigoCidadeIncidencia || "").toString(),
                content: dados.descricaoCidadeIncidencia || "",
            };

        nfsePrefeitura.dados.id = dados.id;
        nfsePrefeitura.dados.numero = dados.numero;
        nfsePrefeitura.dados.status = dados.status;
        nfsePrefeitura.dados.mensagemErro = dados.mensagemErro;
        nfsePrefeitura.dados.urlReceita = dados.urlReceita;
        nfsePrefeitura.dados.urlPdf = dados.urlPdf;
        nfsePrefeitura.dados.urlXml = dados.urlXml;

        nfsePrefeitura.dados.tomador = dados.tomador;
        nfsePrefeitura.dados.servico = dados.servico;
        nfsePrefeitura.dados.locacao = dados.locacao;
        nfsePrefeitura.dados.codigoCidadeIncidencia = descricaoCidadeIncidenciaObj.id;
        nfsePrefeitura.dados.descricaoCidadeIncidencia = descricaoCidadeIncidenciaObj;
        nfsePrefeitura.dados.descricao = dados.descricao;
        nfsePrefeitura.dados.json = dados.json;
        nfsePrefeitura.dados.valorNota = dados.valorNota;
        nfsePrefeitura.dados.emails = Array.isArray(dados.emails)
            ? dados.emails
            : (dados.emails ? String(dados.emails).split(/[;,]/).map(email => email.trim()).filter(Boolean) : []);

        nfsePrefeitura.regimeTributario.optanteSimplesNacional = !!regimeTributario.optanteSimplesNacional;
        nfsePrefeitura.regimeTributario.regimeTributario =
            OpcoesTributarias.regimeTributario.find(x => x.id == String(regimeTributarioId))
            || nfsePrefeitura.regimeTributario.regimeTributario;
        nfsePrefeitura.regimeTributario.regimeEspecialTributacao =
            OpcoesTributarias.regimeTributarioEspecial.find(x => x.id == String(regimeEspecialTributacaoId))
            || nfsePrefeitura.regimeTributario.regimeEspecialTributacao;
        nfsePrefeitura.regimeTributario.incentivadorCultural = !!regimeTributario.incentivadorCultural;
        nfsePrefeitura.regimeTributario.naturezaOperacao =
            OpcoesTributarias.naturezaOperacao.find(x => x.id == String(naturezaOperacaoId))
            || nfsePrefeitura.regimeTributario.naturezaOperacao;
        nfsePrefeitura.regimeTributario.codigoIndicadorOperacao =
            OpcoesTributarias.codigoIndicadorOperacao.find(x => x.id == String(codigoIndicadorOperacaoId))
            || nfsePrefeitura.regimeTributario.codigoIndicadorOperacao;
        nfsePrefeitura.regimeTributario.ibsCbsClassificacaoTributaria =
            OpcoesTributarias.classificacaoTributaria.find(x => x.id == String(ibsCbsClassificacaoTributariaId))
            || nfsePrefeitura.regimeTributario.ibsCbsClassificacaoTributaria;
        nfsePrefeitura.regimeTributario.ibsCbsSituacaoTributaria =
            OpcoesTributarias.tributacaoIBSCBS.find(x => x.id == String(ibsCbsSituacaoTributariaId))
            || nfsePrefeitura.regimeTributario.ibsCbsSituacaoTributaria;

        nfsePrefeitura.imposto.issRetido = imposto.issRetido;
        nfsePrefeitura.imposto.issAliquota = imposto.issAliquota;
        nfsePrefeitura.imposto.pisCofinsRetido = imposto.pisCofinsRetido;
        nfsePrefeitura.imposto.pisAliquota = imposto.pisAliquota;
        nfsePrefeitura.imposto.cofinsAliquota = imposto.cofinsAliquota;
        nfsePrefeitura.imposto.csllAliquota = imposto.csllAliquota;
        nfsePrefeitura.imposto.irAliquota = imposto.irAliquota;
        nfsePrefeitura.imposto.ibsAliquota = ibs.ibsMunAliquota ?? ibs.ibsAliquota ?? imposto.ibsAliquota;
        nfsePrefeitura.imposto.cbsAliquota = cbs.cbsAliquota ?? imposto.cbsAliquota;

        nfsePrefeitura.transparencia.percentualTotalTributosFederais = transparencia.percentualTotalTributosFederais;
        nfsePrefeitura.transparencia.percentualTotalTributosEstaduais = transparencia.percentualTotalTributosEstaduais;
        nfsePrefeitura.transparencia.percentualTotalTributosMunicipais = transparencia.percentualTotalTributosMunicipais;
    }
}
